import { cookieDomainForHost } from '../RouteUtils';
import { TABLERUN_APEX_HOST } from '../tablerun/hosts';

export const DEVICE_ID_HANDOFF_PARAM = 'bt';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The device id handed across the shef.com → tablerun.com redirect, or null.
 *
 * Shape-validated before adoption so a crafted link cannot put arbitrary values into the
 * analytics keyspace. Deliberately not in `TrackingParams`' forwarded-param allowlist: that list
 * forwards params arriving on an inbound URL, which would let anyone pin a visitor's device id.
 */
export const parseHandoffDeviceId = (raw: unknown): string | null =>
  typeof raw === 'string' && UUID_PATTERN.test(raw) ? raw : null;

/**
 * The raw handoff param is only ever legitimate on a request/page load that landed on a TableRun
 * host — the handoff exists to carry a device id from the shef.com redirect onto tablerun.com.
 * Gating on the host stops a `?bt=` crafted onto a shef.com (or any non-TableRun) URL from
 * laundering an attacker-chosen device id onto a first-touch visitor, whether it is adopted on the
 * server (a raw `Host` header, which may carry a port) or in the browser fallback path
 * (`window.location.hostname`) — `cookieDomainForHost` normalizes either shape.
 */
export const deviceIdHandoffParamForHost = (host: string | undefined, rawHandoffParam: unknown): unknown =>
  cookieDomainForHost(host) === TABLERUN_APEX_HOST ? rawHandoffParam : undefined;
